module.exports = __webpack_public_path__ + "img/17.b065c30b.svg";